import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Routing from "./config/Routing";

function App() {
  return <Routing />;
}

export default App;
